document.addEventListener("DOMContentLoaded", () => {
  const menuLinks = document.querySelectorAll(".menu_nav_2 .menu_link");
  const contentWrapper = document.querySelector(".nav_2_content_wrapper");
  const mainContainer = document.querySelector(".link_container");
  const searchContainer = document.querySelector(".search_container");
  const returnButtons = document.querySelector(".return_to_shop");

  // Track the currently active content
  let activeBlockId = null;

  menuLinks.forEach((link) => {
    link.addEventListener("click", () => {
      const blockId = link.getAttribute("data-block-id");

      // Remove active class from all links
      menuLinks.forEach((item) => {
        item.classList.remove("active");
      });

      // Add active class to clicked link
      link.classList.add("active");

      // If content wrapper is already visible, we're switching between blocks
      const isSwitchingBlocks =
        contentWrapper.style.display === "flex" && activeBlockId !== blockId;

      if (isSwitchingBlocks) {
        // Fade out current content
        const currentContent = document.querySelector(
          `.nav_2_body[data-block-id="${activeBlockId}"]`
        );
        const currentImages = document.querySelector(
          `.nav_2_image_wrapper[data-block-id="${activeBlockId}"]`
        );

        if (currentContent) currentContent.style.opacity = "0";
        if (currentImages) currentImages.style.opacity = "0";

        setTimeout(() => {
          // Hide current content
          if (currentContent) currentContent.style.display = "none";
          if (currentImages) currentImages.style.display = "none";

          // Show new content but keep invisible
          const selectedContent = document.querySelector(
            `.nav_2_body[data-block-id="${blockId}"]`
          );
          const selectedImages = document.querySelector(
            `.nav_2_image_wrapper[data-block-id="${blockId}"]`
          );

          if (selectedContent) {
            selectedContent.style.display = "block";
            selectedContent.style.opacity = "0";
          }
          if (selectedImages) {
            selectedImages.style.display = "block";
            selectedImages.style.opacity = "0";

            initNav2Dots(selectedImages); // dots function
          }

          // Fade in new content
          setTimeout(() => {
            if (selectedContent) selectedContent.style.opacity = "1";
            if (selectedImages) selectedImages.style.opacity = "1";

            // Update active block ID
            activeBlockId = blockId;
          }, 50);
        }, 150);
      } else {
        // Original code for first transition from main menu
        mainContainer.style.opacity = "0";
        searchContainer.style.opacity = "0";

        setTimeout(() => {
          mainContainer.style.visibility = "hidden";
          searchContainer.style.visibility = "hidden";

          contentWrapper.style.display = "flex";
          contentWrapper.style.opacity = "0";

          // Hide all content and image sections
          document.querySelectorAll(".nav_2_body").forEach((content) => {
            content.style.display = "none";
          });
          document
            .querySelectorAll(".nav_2_image_wrapper")
            .forEach((wrapper) => {
              wrapper.style.display = "none";
            });

          // Show selected content and images but keep invisible
          const selectedContent = document.querySelector(
            `.nav_2_body[data-block-id="${blockId}"]`
          );
          const selectedImages = document.querySelector(
            `.nav_2_image_wrapper[data-block-id="${blockId}"]`
          );

          if (selectedContent) {
            selectedContent.style.display = "block";
            selectedContent.style.opacity = "0";
          }
          if (selectedImages) {
            selectedImages.style.display = "block";
            selectedImages.style.opacity = "0";

            initNav2Dots(selectedImages); //dots function
          }

          // Fade in content wrapper and elements
          setTimeout(() => {
            contentWrapper.style.opacity = "1";
            if (selectedContent) selectedContent.style.opacity = "1";
            if (selectedImages) selectedImages.style.opacity = "1";

            // Update active block ID
            activeBlockId = blockId;
          }, 50);
        }, 150);
      }
    });
  });

  // Return to shop functionality with fade
  returnButtons.addEventListener("click", () => {
    contentWrapper.style.opacity = "0";

    menuLinks.forEach((link) => {
      link.classList.remove("active");
    });

    setTimeout(() => {
      contentWrapper.style.display = "none";

      mainContainer.style.visibility = "visible";
      searchContainer.style.visibility = "visible";
      mainContainer.style.opacity = "0";
      searchContainer.style.opacity = "0";

      // Reset active block ID
      activeBlockId = null;

      setTimeout(() => {
        mainContainer.style.opacity = "1";
        searchContainer.style.opacity = "1";
      }, 50);
    }, 150);
  });

  // function for footer open

  window.openMenuNav2ByBlockId = function (blockId) {
    const menuLinks = document.querySelectorAll(".menu_nav_2 .menu_link");
    const contentWrapper = document.querySelector(".nav_2_content_wrapper");
    const mainContainer = document.querySelector(".link_container");
    const searchContainer = document.querySelector(".search_container");
    let activeBlockId = null;

    // Find the link with the correct blockId
    const link = Array.from(menuLinks).find(
      (l) => l.getAttribute("data-block-id") === blockId
    );
    if (!link) return;

    // Remove active class from all links
    menuLinks.forEach((item) => {
      item.classList.remove("active");
    });

    // Add active class to clicked link
    link.classList.add("active");

    // If content wrapper is already visible, we're switching between blocks
    const isSwitchingBlocks =
      contentWrapper.style.display === "flex" && activeBlockId !== blockId;

    if (isSwitchingBlocks) {
      // Fade out current content
      const currentContent = document.querySelector(
        `.nav_2_body[data-block-id="${activeBlockId}"]`
      );
      const currentImages = document.querySelector(
        `.nav_2_image_wrapper[data-block-id="${activeBlockId}"]`
      );

      if (currentContent) currentContent.style.opacity = "0";
      if (currentImages) currentImages.style.opacity = "0";

      setTimeout(() => {
        // Hide current content
        if (currentContent) currentContent.style.display = "none";
        if (currentImages) currentImages.style.display = "none";

        // Show new content but keep invisible
        const selectedContent = document.querySelector(
          `.nav_2_body[data-block-id="${blockId}"]`
        );
        const selectedImages = document.querySelector(
          `.nav_2_image_wrapper[data-block-id="${blockId}"]`
        );

        if (selectedContent) {
          selectedContent.style.display = "block";
          selectedContent.style.opacity = "0";
        }
        if (selectedImages) {
          selectedImages.style.display = "block";
          selectedImages.style.opacity = "0";
          if (typeof initNav2Dots === "function") initNav2Dots(selectedImages);
        }

        // Fade in new content
        setTimeout(() => {
          if (selectedContent) selectedContent.style.opacity = "1";
          if (selectedImages) selectedImages.style.opacity = "1";
          // Update active block ID
          activeBlockId = blockId;
        }, 50);
      }, 150);
    } else {
      // Original code for first transition from main menu
      mainContainer.style.opacity = "0";
      searchContainer.style.opacity = "0";

      setTimeout(() => {
        mainContainer.style.visibility = "hidden";
        searchContainer.style.visibility = "hidden";

        contentWrapper.style.display = "flex";
        contentWrapper.style.opacity = "0";

        // Hide all content and image sections
        document.querySelectorAll(".nav_2_body").forEach((content) => {
          content.style.display = "none";
        });
        document.querySelectorAll(".nav_2_image_wrapper").forEach((wrapper) => {
          wrapper.style.display = "none";
        });

        // Show selected content and images but keep invisible
        const selectedContent = document.querySelector(
          `.nav_2_body[data-block-id="${blockId}"]`
        );
        const selectedImages = document.querySelector(
          `.nav_2_image_wrapper[data-block-id="${blockId}"]`
        );

        if (selectedContent) {
          selectedContent.style.display = "block";
          selectedContent.style.opacity = "0";
        }
        if (selectedImages) {
          selectedImages.style.display = "block";
          selectedImages.style.opacity = "0";
          if (typeof initNav2Dots === "function") initNav2Dots(selectedImages);
        }

        // Fade in content wrapper and elements
        setTimeout(() => {
          contentWrapper.style.opacity = "1";
          if (selectedContent) selectedContent.style.opacity = "1";
          if (selectedImages) selectedImages.style.opacity = "1";
          // Update active block ID
          activeBlockId = blockId;
        }, 50);
      }, 150);
    }
  };

  // dots initializer
  function initNav2Dots(wrapper) {
    console.log("initNav2Dots called for", wrapper);
    const imageContainer = wrapper.querySelector(".nav_2_image_container");
    const images = wrapper.querySelectorAll(".nav_2_image, .nav_2_video");
    const dots = wrapper.querySelectorAll(".nav-dot");
    const dotsContainer = wrapper.querySelector(".nav_2_image_dots");
    console.log("dotsContainer:", dotsContainer);

    if (
      !imageContainer ||
      images.length <= 1 ||
      !dotsContainer ||
      dots.length === 0
    )
      return;

    // Remove .visible from all other dots containers
    document.querySelectorAll(".nav_2_image_dots.visible").forEach((el) => {
      if (el !== dotsContainer) el.classList.remove("visible");
    });

    // Activate first dot
    dots.forEach((dot) => dot.classList.remove("active"));
    if (dots[0]) dots[0].classList.add("active");

    // Dot click: scroll to image horizontally
    dots.forEach((dot, idx) => {
      dot.onclick = () => {
        const targetImage = images[idx];
        if (targetImage && imageContainer) {
          imageContainer.scrollTo({
            left: targetImage.offsetLeft,
            behavior: "smooth",
          });
        }
      };
    });

    // --- Mobile dots fade in/out ---
    function showDots() {
      console.log("showDots called for", dotsContainer);
      dotsContainer.classList.add("visible");
      clearTimeout(dotsContainer._dotsTimeout);
      dotsContainer._dotsTimeout = setTimeout(() => {
        dotsContainer.classList.remove("visible");
        console.log("visible removed from", dotsContainer);
      }, 1000);
    }

    // On scroll: update active dot and fade dots
    imageContainer.onscroll = null;
    imageContainer.onscroll = () => {
      let mostVisibleIndex = 0;
      let maxVisibility = 0;
      images.forEach((img, idx) => {
        const rect = img.getBoundingClientRect();
        const containerRect = imageContainer.getBoundingClientRect();
        const imgLeft = rect.left - containerRect.left;
        const imgWidth = rect.width;
        const containerWidth = imageContainer.clientWidth;
        const visibleWidth = Math.min(
          Math.max(
            0,
            Math.min(containerWidth, imgLeft + imgWidth) - Math.max(0, imgLeft)
          ),
          imgWidth
        );
        const visibility = visibleWidth / imgWidth;
        if (visibility > maxVisibility) {
          maxVisibility = visibility;
          mostVisibleIndex = idx;
        }
      });
      dots.forEach((dot, idx) => {
        dot.classList.toggle("active", idx === mostVisibleIndex);
      });
      if (window.innerWidth <= 573) showDots();
    };

    // Show dots initially on mobile for this instance only
    if (window.innerWidth <= 573) showDots();
  }
});
